module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/67f61a6797faad9f0285517206b5ae27.png";